import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { Switch, Toast, Button } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import DoctorAvatar from '../../static/images/doctor_avatar.png';
import { userAgeement, privacyPolicy } from './privacy';
import utils from '../../../utils/utils';

const api = new ApiCore();

const Home = (props: any) => {

    const [template, setTemplate] = useState<any>('');

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        const urlParms = utils.getUrlParams();
        let title = '';
        let renderText = '';
        if (urlParms.tab === 'user') {
            title = '用户协议';
            renderText = userAgeement;
        } else {
            title = '隐私协议';
            renderText = privacyPolicy;
        }
        setTemplate(renderText);
    }

    return (
        <div className={styles.doctor_privacy_content}>
            <div dangerouslySetInnerHTML={{ __html: template }}></div>
        </div>
    )
}

export default withRouter(Home);